import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal';
import { IData } from '../core/models/lightbox';
import {IMetrics} from '../core/models/metrics';
import {metricsEvent} from '../core/classes/api';
import YouTube from 'react-youtube';
import moment from 'moment-timezone';

export default class LightboxDR extends React.Component<IData> {
     state:any = {video:false, duration:null, days: 0, hrs: 0, mins: 0, secs:0};
     constructor(props: IData) {
          super(props);
          this.closeModal = this.closeModal.bind(this);
          this.renderMarkup = this.renderMarkup.bind(this);
          this.metricHandler = this.metricHandler.bind(this);
          this.YTStateHandler = this.YTStateHandler.bind(this);
     }

     componentDidMount(){
          const interval = 1000; // 1 sec  
          // const container = document.getElementById('sliver-container') as HTMLElement;         
          // container.setAttribute('style', 'display:none!important');
          // setTimeout(() => container.remove(), 1000);      
          const eventTime = moment.tz(this.props.endDate, "America/Los_Angeles");
          const currentTime = moment.tz();        
          var duration:any = moment.duration(eventTime.diff(currentTime));      
          const intervalId = setInterval(() => {
               duration = moment.duration(duration - interval, 'millisecond');
               this.setState({...this.state, duration: duration});               
               this.setState({...this.state, days: duration.days(), hrs:duration.hours(), mins: duration.minutes(), secs: duration.seconds()});
               if(duration.asSeconds() <= 0) clearInterval(intervalId);
          }, interval);
     }

     public closeModal() {
          const event:IMetrics = {
               category: this.props.type,
               referer: window.location.href,
               campaign: this.props.campaign,
               action: 'dismiss modal'
          }
          metricsEvent(event);
          this.componentWillUnmount();
     }

     public metricHandler(){
          const event:IMetrics = {
               category: this.props.type,
               referer: window.location.href,
               campaign: this.props.campaign,
               action: 'cta taken'
          }
          metricsEvent(event);
     }

     public renderMarkup(html: any): any {
          return { __html: html };
     }

     componentWillUnmount() {
          const element = document.getElementById('directresponse-module') as HTMLElement;
          ReactDOM.unmountComponentAtNode(element);
     }

     public YTStateHandler(e:any){
          const {data} = e;          
          if( data === 0) this.setState({...this.state, video: false});         
     }
     

     public render() {       
          const {video, days, hrs, mins, secs} = this.state;
          const opts:any = {playerVars:{cc_load_policy:1, rel:0, autoplay: 1, mute:1}}; 
                    
          return (
               <div>
                    {video?
                    <Modal
                         handleClose={this.closeModal}
                         background="https://pancan-react-bucket.s3.us-west-1.amazonaws.com/assets/mindy-lightbox-video-bck.jpg?v=1"
                         class={this.props.class}>

                         <div className={'main-body ' + this.props.testKey}>
                              <div className='videoWrapper'>
                                   { <YouTube videoId='0OTRXxlXn-k' opts={opts} onStateChange={this.YTStateHandler} />}
                              </div>                         
                              <div className="button-holder special-version">
                                   <a
                                        data-trigger={this.props.dataTrigger}
                                        onClick={this.closeModal}
                                        href={this.props.content.footer.button.link}
                                        // target="_blank"
                                        className={this.props.content.footer.button.color
                                             ? 'button-exec ' + this.props.content.footer.button.color
                                             : 'button-exec '} dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.button.text)} />
                              </div>
                              <p className="type" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.type)} />
                              <p
                                   className="type-sub"
                                   dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.subType)} />
                         </div>
                    </Modal>
                    :
                    <Modal
                         handleClose={this.closeModal}
                         background={this.props.backgroundLink}
                         class={this.props.class}>

                         <div className={'main-body ' + this.props.testKey}>
                              <p className="title" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.title)} />
                              <p className="sutTitle" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.subTitle)} />
                              <p className="body" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.body)} />
                              {this.props.testKey === 'pseventWeek' ? <div className="countdown-container">
                                   <div>
                                        <div className="d-value">{days}</div>
                                        <div className="d-label">Days</div>
                                   </div>
                                   <div>
                                   <div className="d-value">{hrs}</div>
                                   <div className="d-label">Hours</div>
                                   </div>
                                   <div>
                                        <div className="d-value">{mins}</div>
                                        <div className="d-label">Mins</div>
                                   </div>
                                   <div>
                                        <div className="d-value">{secs}</div>
                                        <div className="d-label">secs</div>
                                   </div>
                              </div>:null}
                              <br /> 
                              <div className="button-holder">
                                   <a
                                        data-trigger={this.props.dataTrigger}
                                        onClick={this.closeModal}
                                        href={this.props.content.footer.button.link}
                                        // target="_blank"
                                        className={this.props.content.footer.button.color
                                             ? 'button-exec ' + this.props.content.footer.button.color
                                             : 'button-exec '} dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.button.text)} />
                                   {this.props.testKey === 'DR24Agus' || this.props.testKey === 'DR24Sep'?
                                   <a
                                   data-trigger={this.props.dataTrigger}
                                   onClick={this.metricHandler}
                                   href={this.props.content.footer.buttonAux.link}
                                   // target="_blank"
                                   className={this.props.content.footer.buttonAux.color
                                        ? 'button-exec ' + this.props.content.footer.buttonAux.color
                                        : 'button-exec '} dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.buttonAux.text)} />
                                   :''}
                                   <span className="dismiss" onClick={this.closeModal} style={{textTransform: 'capitalize', textDecoration: 'underline', fontSize: '13px'}}>Maybe Later.</span>
                              </div>
                              <p className="type" dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.type)} />
                              <p
                                   className="type-sub"
                                   dangerouslySetInnerHTML={this.renderMarkup(this.props.content.footer.subType)} />
                         </div>
                    </Modal>
                    
                    }
                    
                   
               </div>
               
          );
     }
}    